function reactiveStateObjKey(obj, key) {
  // let the state data reactive
  Vue.set(obj, key, "");
}
function getCreatorLevelFilter(creatorLevel) {
  if (creatorLevel === CONSTANT.CREATOR_LEVEL.ENTRY) {
    return CONSTANT.CREATOR_LEVEL_FILTER.ENTRY;
  } else if (creatorLevel === CONSTANT.CREATOR_LEVEL.MARKETER) {
    return CONSTANT.CREATOR_LEVEL_FILTER.MARKETER;
  } else {
    return CONSTANT.CREATOR_LEVEL_FILTER.PREMIUM;
  }
}
const CREATOR_LEVEL = {
  ENTRY: "entry",
  MARKETER: "marketer",
  PREMIUM: "premium",
};
const typeInfo = [
  {
    type: "inskin",
    name: "Skin",
    src: require("@/assets/inskin.png"),
    assets: [0],
    devices: [0],
    features: [3],
    sizes: {
      Top_Image: "custom widthx400~600*1",
      Bottom_Image: "custom widthx100~150*1",
      Left_Image: "custom size*1",
      Right_Image: "custom size*1",
    },
    formats: ["JPG", "PNG", "GIF"],
    creator_level: CREATOR_LEVEL.ENTRY,
  },
  {
    type: "outstream",
    name: "Outstream",
    src: require("@/assets/outstream.png"),
    assets: [1],
    devices: [0],
    features: [],
    sizes: { Video: "640x360*1" },
    formats: ["MP4"],
    creator_level: CREATOR_LEVEL.ENTRY,
  },
  {
    type: "pushdown",
    name: "Pushdown",
    src: require("@/assets/pushdown.gif"),
    assets: [0],
    devices: [0],
    features: [1],
    sizes: { Initial_Image: "970x250*1", Expanded_Image: "970x500*1" },
    formats: ["JPG", "PNG", "GIF"],
    creator_level: CREATOR_LEVEL.MARKETER,
  },
  {
    type: "pushdownWithOutstream",
    name: "Pushdown With Video",
    src: require("@/assets/pushdownWithOutstream.gif"),
    assets: [0, 1],
    devices: [0],
    features: [1, 4],
    sizes: {
      Initial_Image: "970x250*1",
      Expanded_Image: "970x500*1",
      Video: "custom size*1",
    },
    formats: ["JPG", "PNG", "GIF", "MP4"],
    creator_level: CREATOR_LEVEL.PREMIUM,
  },
  {
    type: "parallaxScrolling",
    name: "Parallax Scrolling",
    src: require("@/assets/parallaxScrolling.gif"),
    assets: [0],
    devices: [1],
    features: [2],
    sizes: { Image: "320x480*1~5" },
    formats: ["JPG", "PNG", "GIF"],
    creator_level: CREATOR_LEVEL.MARKETER,
  },
  {
    type: "parallaxScrollingWithOutstream",
    name: "Parallax Scrolling With Video",
    src: require("@/assets/parallaxScrollingWithOutstream.gif"),
    assets: [0, 1],
    devices: [1],
    features: [2, 4],
    sizes: { Image: "320x480*1~5", Video: "320x180*1" },
    formats: ["JPG", "PNG", "GIF", "MP4"],
    creator_level: CREATOR_LEVEL.MARKETER,
  },
  {
    type: "parallaxScrollingFlip",
    name: "Parallax Scrolling Flip",
    src: require("@/assets/parallaxScrollingWithOutstream.gif"),
    assets: [0, 1],
    devices: [1],
    features: [2, 4],
    sizes: { Image: "320x400*1~5", Video: "320x180*1" },
    formats: ["JPG", "PNG", "GIF", "MP4"],
    creator_level: CREATOR_LEVEL.MARKETER,
  },
  {
    type: "scrollingBox",
    name: "Scrolling Box",
    src: require("@/assets/scrollingBox.gif"),
    assets: [0],
    devices: [1],
    features: [2, 3, 4],
    sizes: { Image: "320x80*2~10" },
    formats: ["JPG", "PNG", "GIF"],
    creator_level: CREATOR_LEVEL.MARKETER,
  },
  {
    type: "carousel",
    name: "Carousel",
    src: require("@/assets/carousel.gif"),
    assets: [0],
    devices: [0],
    features: [2, 4],
    sizes: { Image: "350x250*5~10" },
    formats: ["JPG", "PNG", "GIF"],
    creator_level: CREATOR_LEVEL.ENTRY,
  },
  {
    type: "banner",
    name: "Banner",
    src: require("@/assets/banner.png"),
    assets: [0],
    devices: [0, 1],
    features: [],
    sizes: { Image: "custom size*1" },
    formats: ["JPG", "PNG", "GIF"],
    creator_level: CREATOR_LEVEL.ENTRY,
  },
  {
    type: "bannerWithOutstream",
    name: "Banner With Video",
    src: require("@/assets/bannerWithOutstream.png"),
    assets: [0, 1],
    devices: [0, 1],
    features: [],
    sizes: {
      Image: "custom size*1",
      Video: "custom size*1",
    },
    formats: ["JPG", "PNG", "GIF", "MP4"],
    creator_level: CREATOR_LEVEL.ENTRY,
  },
  {
    type: "spinner",
    name: "Spinner",
    src: require("@/assets/spinner.gif"),
    assets: [0],
    devices: [1],
    features: [2, 3],
    sizes: {
      Top_Image: "630x630*1~2",
      Bottom_Image: "630x630*1~2",
      Left_Image: "630x630*1~2",
      Right_Image: "630x630*1~2",
    },
    formats: ["PNG", "GIF"],
    creator_level: CREATOR_LEVEL.MARKETER,
  },
  {
    type: "cards",
    name: "Cards",
    src: require("@/assets/cards.gif"),
    assets: [0],
    devices: [1],
    features: [2, 3, 4],
    sizes: { Image: "640x360*4" },
    formats: ["JPG", "PNG", "GIF"],
    creator_level: CREATOR_LEVEL.MARKETER,
  },
  {
    type: "rollingCastle",
    name: "Rolling Castle",
    src: require("@/assets/rollingCastle.gif"),
    assets: [0, 1],
    devices: [1],
    features: [0, 2, 3, 4],
    sizes: {
      Background_Image: "640x1138*1",
      Card_Image: "300x180*5",
      Banner_Image: "640x1138*4~5",
      Banner_Video: "640x1138*0~1",
    },
    formats: ["JPG", "PNG", "GIF", "MP4"],
    creator_level: CREATOR_LEVEL.MARKETER,
  },
  {
    type: "switch",
    name: "Switch",
    src: require("@/assets/switch.gif"),
    assets: [0],
    devices: [0, 1],
    features: [2, 4],
    sizes: { Image: "300x250*2~4" },
    formats: ["JPG", "PNG", "GIF"],
    creator_level: CREATOR_LEVEL.ENTRY,
  },
  {
    type: "rotatingFerrisWheel",
    name: "Rotating Ferris Wheel",
    src: require("@/assets/marquee.gif"),
    assets: [0],
    devices: [1],
    features: [3, 4],
    sizes: { Image: "750x300*3" },
    formats: ["JPG", "PNG", "GIF"],
    creator_level: CREATOR_LEVEL.MARKETER,
  },
  {
    type: "marquee",
    name: "Marquee",
    src: require("@/assets/marquee.gif"),
    assets: [0],
    devices: [1],
    features: [3, 4],
    sizes: { Image: "320x100/750x300*3~5" },
    formats: ["JPG", "PNG", "GIF"],
    creator_level: CREATOR_LEVEL.MARKETER,
  },
  {
    type: "swap",
    name: "Swap",
    src: require("@/assets/swap.gif"),
    assets: [0],
    devices: [0, 1],
    features: [1],
    sizes: { Image: "300x250*2" },
    formats: ["JPG", "PNG", "GIF"],
    creator_level: CREATOR_LEVEL.ENTRY,
  },
  {
    type: "countDown",
    name: "Count Down",
    src: require("@/assets/countDown.gif"),
    assets: [0],
    devices: [0, 1],
    features: [4],
    sizes: { Image: "300x250/320x480*4" },
    formats: ["JPG", "PNG", "GIF"],
    creator_level: CREATOR_LEVEL.MARKETER,
  },
  {
    type: "vast",
    name: "VAST",
    src: require("@/assets/outstream.png"),
    assets: [1],
    devices: [0, 1],
    features: [0],
    sizes: { Video: "auto*1" },
    formats: ["MP4"],
    creator_level: CREATOR_LEVEL.PREMIUM,
  },
  {
    type: "postAd",
    name: "Post Ad",
    src: require("@/assets/postAdImage.png"),
    assets: [0, 1],
    devices: [1],
    features: [1],
    sizes: { Image: "custom size*1", Advertiser_Icon: "1:1*1" },
    formats: ["JPEG", "PNG", "GIF"],
    creator_level: CREATOR_LEVEL.MARKETER,
  },
  {
    type: "postAdWithOutstream",
    name: "Post Ad With Video",
    src: require("@/assets/postAdVideo.png"),
    assets: [0, 1],
    devices: [1],
    features: [1],
    sizes: {
      Image: "custom size*1",
      Advertiser_Icon: "1:1*1",
    },
    formats: ["MP4"],
    creator_level: CREATOR_LEVEL.PREMIUM,
  },
  {
    type: "dataDriven",
    name: "Data Driven",
    src: require("@/assets/dataDrivenCreative.gif"),
    assets: [0],
    devices: [0, 1],
    features: [],
    sizes: { Image: "custom size*1~10" },
    formats: ["JPG", "PNG", "GIF"],
    creator_level: CREATOR_LEVEL.MARKETER,
  },
];

export default {
  namespaced: true,
  state: {
    url: `/api/creatives`,
    creatives: [],
    filterOptions: {
      assets: {
        0: "Image",
        1: "Video",
      },
      features: {
        0: "Full-screen",
        1: "Expandable",
        2: "Slidable",
        3: "Floating",
        4: "Repeating",
      },
      devices: {
        0: "desktop",
        1: "mobile",
      },
    },
    typeInfo,
    typeMapping: typeInfo.reduce(
      (map, { type, name }) => ({ ...map, [type]: name }),
      {}
    ),
    selections: [],
  },
  getters: {
    getCreatives: (state) => state.creatives,
    getCreativeById: (state) => (id) =>
      state.creatives.find(
        (creative) => creative._id === id || creative.creative_id === id
      ),
  },
  mutations: {
    setSelections: (state, data) => {
      state.selections = _.map(data, (item) => {
        item.typeName = state.typeMapping[item._type];
        item.tag = getTemplate(item);
        return item;
      });
    },
    setCreatives: (state, data) => {
      state.selections = [];
      state.creatives = _.map(data, (item) => {
        item.folder = item.folder || "";
        item.advertiser = item.advertiser || "";
        item.campaign = item.campaign || "";
        return item;
      });
    },
    insertCreative: (state, data) => {
      data.folder = data.folder || "";
      data.advertiser = data.advertiser || "";
      data.campaign = data.campaign || "";
      state.creatives.push(data);
    },
    updateCreativeById: (state, data) => {
      const index = state.creatives.findIndex(
        (creative) => creative._id === data._id
      );
      // delete or update item of array
      if (data.is_archived) {
        state.creatives.splice(index, 1);
      } else {
        data.folder = data.folder || "";
        state.creatives[index] = _.assign(state.creatives[index], data);
      }
    },
    insertIsSuitCreatorLevelToTypeInfo: (state, data) => {
      let CreatorLevelFilter = getCreatorLevelFilter(data);
      state.typeInfo.forEach((res) => {
        reactiveStateObjKey(res, "isSuitCreatorLevel");
        if (CreatorLevelFilter.includes(res.creator_level)) {
          res.isSuitCreatorLevel = true;
        } else {
          res.isSuitCreatorLevel = false;
        }
      });
    },
  },
  actions: {
    async getCreatives({ commit, state }, params) {
      try {
        const { data } = await axios.get(state.url, { params });
        commit("setCreatives", data);
      } catch (e) {
        throw e;
      }
    },
    async getCreativeById({ commit, state }, id) {
      try {
        const { data } = await axios.get(`${state.url}/${id}`);
        commit("insertCreative", data);
      } catch (e) {
        throw e;
      }
    },
    async createCreative({ commit, state }, setObj) {
      try {
        const { data } = await axios.post(state.url, setObj);
        commit("insertCreative", data);
      } catch (e) {
        throw e;
      }
    },
    async updateCreativeById({ commit, state }, { id, setObj }) {
      try {
        const { data } = await axios.put(`${state.url}/${id}`, setObj);
        commit("updateCreativeById", data);
      } catch (e) {
        throw e;
      }
    },
    async patchCreativeById({ commit, state }, { id, setObj }) {
      try {
        const { data } = await axios.patch(`${state.url}/${id}`, setObj);
        commit("updateCreativeById", data);
      } catch (e) {
        throw e;
      }
    },
    async patchCreatives({ commit, state }, { setObj }) {
      try {
        setObj.ids = state.selections.map((i) => i._id);
        const res = await axios.patch(`${state.url}`, setObj);
        res.data.forEach((data) => {
          commit("updateCreativeById", data);
        });
      } catch (e) {
        throw e;
      }
    },
    async cloneCreativesByIds({ commit, state }, setObj) {
      try {
        const res = await axios.post(`${state.url}/clone`, setObj);
        res.data.creatives.forEach((creative) => {
          commit("insertCreative", creative);
        });
      } catch (e) {
        throw e;
      }
    },
  },
};
